import { useSaveSettings, useSettings } from "../lib/settings";
import TimezonePicker from "./TimezonePicker";
import ThemeToggle from "./ThemeToggle";
import LangPicker from "./LangPicker";

/**
 * Fixed top toolbar visible on every authenticated page: language switcher +
 * quick timezone switcher + light/dark toggle. Pinned to the inline-END edge
 * (`end-*`) so it sits top-right in LTR and mirrors to top-left in RTL. All
 * actions persist to server / localStorage, so switching from any page carries
 * across the whole app.
 */
export default function TopBar() {
  const { settings } = useSettings();
  const saveM = useSaveSettings();

  return (
    <div className="fixed top-3 end-3 sm:top-4 sm:end-4 z-40 flex items-center gap-2">
      <LangPicker />
      <TimezonePicker
        compact
        value={settings.display_timezone}
        onChange={(tz) => saveM.mutate({ display_timezone: tz })}
      />
      <ThemeToggle compact />
    </div>
  );
}
